// Whether the channel list shows each channel's activity meter (#48). Saved to the account like message display
// (/api/me/settings), and in localStorage so it applies before the account loads on this device.
import { useSyncExternalStore } from "react";
import { api } from "./api.ts";

const KEY = "bloom:channel-activity";
const listeners = new Set<() => void>();

function stored(): boolean {
  try {
    return localStorage.getItem(KEY) !== "off";
  } catch {
    return true;
  }
}

let shown = stored();

/** Sets it on this device right away; `save` also stores it on the account for my other devices. */
export function setChannelActivity(next: boolean, { save = true } = {}) {
  shown = next;
  try {
    localStorage.setItem(KEY, next ? "on" : "off");
  } catch {
    // private mode: still applies for this page
  }
  for (const fn of listeners) fn();
  if (save) void api("/me/settings", { method: "PUT", body: { channelActivity: next } }).catch(() => {});
}

export const getChannelActivity = () => shown;

const subscribe = (fn: () => void) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const useChannelActivity = (): boolean => useSyncExternalStore(subscribe, () => shown);
